module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "CHAPTER 1: Over the Mountain"
    }
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9780310412625_epub_toc_r1#c01a"
    }
  }, [_c('span', {
    staticClass: "sm1"
  }, [_vm._v("CHAPTER 1")]), _c('br'), _c('br'), _vm._v(" "), _c('i', [_vm._v("Over the Mountain")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Why art thou cast down, O my soul?"), _c('br'), _vm._v(" and why art thou disquieted within me?")]), _vm._v(" "), _c('br'), _vm._v(" PSALM 42:11"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "dcap"
  }, [_c('b', [_c('em', [_vm._v("G")])])]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENERAL")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENO’S CORPSE WAS THE FIRST")]), _vm._v(" I "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SAW DURING THE")]), _vm._v(" war. As the hour approached midnight on Sunday, September 14"), _c('sup', [_vm._v("th")]), _vm._v(", 1862, the thoroughly winded green recruits, among which I was proud to be numbered, crested South Mountain at Turner’s Gap. The march from Frederick, Maryland, had been long and hot, with few breaks for coffee and rations. When, during the course of the afternoon, the men heard the din of fighting erupt, and when they saw battle smoke enshroud the long ridge ahead of them, each untested man looked about at his mates. He saw jaws clenched, faces drawn, skin pallid, and eyes wide with fear and uncertainty, countenances that mirrored his own.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With nightfall the battle clamor ebbed, then stopped altogether as the men toiled up the mountain toward the gap. All were eager to end the day with a hot cup of coffee and a peaceful night’s sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An ambulance was parked in the grass next to the road. A mule hitched to the front of it stamped nervously as we passed. At the rear of the ambulance a single torch of pitch blazed and "), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("a lone soldier stood guard, head low to his chest, stoop shouldered. He stirred at our approach, raising his head slowly, as if with great effort.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“What unit you boys with?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fourteenth Connecticut Volunteer Infantry of French’s Division,” someone answered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sentinel stood with his back to the torchlight, his black slouch hat pulled low, casting his visage deeply in the shadow of the half moon. He appeared a faceless phantom, breathing and moving as one of the living, but when he spoke, his voice was hollow and lifeless.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you hear about General Reno?” He waved at the ambulance behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No one said a word.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Major General Jesse Lee Reno — a great patriot, a soldier’s soldier, a true fighting man, not like some of these other dandies we have. We loved him like a father.” The man spat at the ground. “Now he’s dead.” The man shook an upraised fist at the darkness to the south. “My general. He’s dead and I wouldn’t believe it unless I’d seen it myself. We’d already whipped those devils, but they just shot him down as they turned to run.” The man lowered his head to his chest again, his voice a murmur. “He died with the setting of the sun.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Still none of us had any words for him. Our feet began to shuffle forward, leaving the sentinel to resume his mournful vigil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The night will be long and dark,” he called to anyone within earshot. “What will become of us now?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("A few minutes later we came upon a large field. Gasps of horror arose from the column as spectral shadows flitted from place to place about the starlit meadow. But as our eyes adjusted, the shadowy figures turned out to be some of our own troops. There had been a great and bloody fight upon that mountain and ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("our boys had won it, but there had been many casualties, both Union and Confederate. Burial details worked by torchlight on both sides of the road, moving from one black heap to another, checking for any signs of life before tagging the body for interment. The bodies of our Federal comrades would be the first to be retrieved. If time and will allowed it, the enemy dead would also be buried, albeit in cursory fashion. Otherwise, their corpses would be left to the elements and their rotting flesh would see yet another battle, this time between the birds of the air or the beasts of the field which would carry off the choicest parts.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/19-1.jpg"
    }
  })])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("The regiment was ordered off the road to camp for the night in this field of death. We moved slowly among the corpses, ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("carefully trying not to stumble over them in the darkness or tread on any flailed appendage. Some of the men were fortunate to find enough room to spread out their rubber blankets and build campfires, but for most, the stiffening, bloating corpses of the enemy dead had to be moved aside and even stacked one upon the other to clear sufficient space. It was the first time I had seen dead bodies like that. I had been to several memorial services in our church, but the body of the deceased was always someone known to us, possibly a loved one, and the body was always laid out carefully in a simple coffin, making it easy for the viewer to imagine the person asleep rather than dead. But in that field, the pale moonlight revealed the bodies of those pitiable soldiers to be grotesquely contorted in every imaginable way, a terrible testament to the agonies suffered in the last moments of their struggles with death.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Michael?” John Robinson, my closest and dearest friend since childhood, was by my side, as he had been during the last seven days of hard marching from Fort Ethan Allen. “Could you ever have imagined this just six weeks ago?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I never … I thought … I don’t know what I thought it would be like. War means killing, but this is so … terrible.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John and I roamed the field in search of an unspoiled place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Here, this looks all right,” John said. “It’s soft and grassy and the closest body is a few yards away.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We began to unroll our rubber blankets. “Nobody forced us into this,” John said. “We volunteered. We talked about it over and over.” John paused for a response, but I offered none. “Are we still agreed that it’s God’s will for us to be here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, you heard me say it. Reverend Preston was most convincing about the evils of slavery.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Easy to say in church on Sunday. But what about here and now?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("“I know, John. Death is suddenly so close—I’m face-to-face ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("with it. I can reach out and touch it, feel it reaching out to touch me.”")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Unless we crawl under a rock, staring death in the face is something we’ll have to get used to. That will be my prayer tonight, that God will calm and steady me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps the worst was the smell of the freshly dead. The sickly sweet odor of blood spilled upon the ground and the more powerful stench of bodies blown apart with their entrails cast to the four winds combined in a reeking aroma that, perhaps even more than sight, spoke sickening volumes of the gore all around. As I lay on my blanket, I could look only upward at the heavenly host above me, or I could close my eyes tightly shut against the hideous specter of those bodies, but I could not shut out the smell. I turned over, face downward to the earth, and tried to will myself to sleep. I buried my face in the crook of my elbow, hoping the odors of earth and grass and India rubber would crowd out the sickening odor of death. At last, I remembered the words of the psalmist and repeated them over and over until they grew into a drumbeat for my troubled heart, "), _c('em', [_vm._v("Thou shalt not be afraid for the terror by night … Thou shalt not be afraid for the terror by night … Thou shalt not be afraid for the terror by night …")])])])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page21"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6914684a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780310412625_epub_c01_r1.vue
// module id = 81
// module chunks = 0